import React, { useEffect, useState } from "react";
import { Projects } from "../../Data/Data";
import greenHomeHero from "../../assest/GreenHome/images/greenHomeHero.jpeg";
import { greenHomeOutterRenderPaths } from "../../assest/imgPaths";

const BannerProduct = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY); // Capture the vertical scroll position
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 950);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="bg-black relative overflow-hidden h-[calc(100vh-56px)] ">
      <img
        src={isLargeScreen ? greenHomeOutterRenderPaths.light : greenHomeHero} // Fallback image for older browsers
        alt="K2 invest green Home banner"
        className="opacity-80 inline-block max-w-full w-full h-[120vh] text-center align-middle object-cover"
        style={{
          transform: `translateY(-${scrollY * 0.1}px)`,
          transition: "transform 1s",
        }}
      />
      <div className="absolute flex flex-col justify-end items-start max-w-[600px] pb-24 pt-36 gap-5 z-20 bottom-0 left-4 md:left-24 h-fit text-primary-light">
        <h1 className="font-gilroy uppercase text-4xl md:text-5xl leading-tight mb-0 mt-0 tracking-widest opacity-100 transform transition-all duration-[0.45s] ease-out delay-[0.6s]">
          {Projects[0].label}
        </h1>
        <div className="font-bpg text-xl md:text-2xl font-normal leading-6  ">
          {Projects[0].address}
        </div>
      </div>
    </div>
  );
};

export default BannerProduct;
